<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 840px; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <Finish
        :ifImage="false"
        :imgUrl="imgUrl"
        :message="score"
        :showWarning="showWarning"
        :showbtn="true"
        :previousScore="previousScore"
        :maxScore="maxScore"
        @nextRoute="nextRouteFunction()"
      />
    </template>
  </div>
</template>

<script>
import Finish from './components/Finish.vue';
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';
import TEMPLATE from '../../../TEMPLATE.vue';

export default {
  name: 'MF01',
  components: {Finish, LoadingMDL},
  props: {
    TEMPLATE,
  },
  data() {
    return {
      text: '00/50',
      imgUrl:
        'https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-image-512.png',
      currentRoute: '',
      loading: true,
      navigate: [],
      score: '',
      templateData: [],
      condition: [],
      startTime: this.$helpers.getDateFormat(),
      code: '',
      section: '',
      v3Data: null,
      v3DisplayScore: null,
      nextPath: null,
      showWarning: false,
      previousScore: 0,
      maxScore: 0,
    };
  },
  methods: {
    nextRouteFunction: function () {
      this.commitPayloadData();
    },
    onLoadData() {
      this.currentRoute = this.$route.name + '-' + this.$route.params.id;
      this.courseData = this.$store.getters['necessary/getLerningCourse'];
      this.code = this.courseData._id;
      this.section = this.$store.getters['necessary/getUserCourseSection'];

      this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
    },
    commitPayloadData() {
      const path = this.navigate.next.action;
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      saveScoreAndProgress: 'v3/saveScoreAndProgress',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
      getScoreResultv4: 'v4-data/getScoreResultv4',
      getSaveScoreResultv4: 'v4-data/getSaveScoreResultv4',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;
      this.loading = true;

      this.v3Data = val;
      const template = val.templates[0];

      this.navigate = template.navigate;

      //for checking if main code is current ?
      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.$store.dispatch('v4/stampCurrentScore', this.v3Data);

      this.$store.dispatch(
        'v4-data/getScoreResultv4',
        this.$store.state.v4.v4DataStack
      );
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'LKS01 Watcher Call');
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    getScoreResultv4: function (val) {
      // console.log(val, 'score result');
      let realScore;
      let realMaxScore;
      const pageType = this.$store.state.v4.v4MainType;

      //f score for show
      if (pageType === 'test' || pageType === 'assignment') {
        realMaxScore = 10;
        if (val.score > 10) {
          realScore = 10;
        } else {
          realScore = val.score;
        }
      } else if (pageType === 'pretest' || pageType === 'posttest') {
        realMaxScore = 30;
        if (val.score > 30) {
          realScore = 30;
        } else {
          realScore = val.score;
        }
      } else {
        realMaxScore = val.maxScore;
        realScore = val.score;
      }

      //assign score
      const userScore = String(realScore).padStart(2, '0');
      const maxScore = String(realMaxScore).padStart(2, '0');
      this.maxScore = maxScore;
      this.score = userScore + '/' + maxScore;
    },
    getSaveScoreResultv4(val) {
      // console.log(val, 'save Completed');
      if (!val) return;

      //check finish status
      if (val.response.finish) {
        this.showWarning = true;
        this.previousScore = val.response.score;
      }
      //loading done after get score
      this.loading = false;
    },
  },
  created() {},
  mounted() {
    this.onLoadData();
    // console.log(this.score);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss"></style>
